import { config } from '@/config';

const API_URL = config.api.url.wallet;

export const createTransactionHistoryQueryKey = (
    transactionId: number | null,
    languageId: number | null,
    token?: string,
): [path: string, transactionId: number, languageId: number, token?: string] | null => {
    if (!transactionId || !languageId) return null;
    else if (token?.length) {
        return [
            `${API_URL}/non-member-payment/${token}/transaction/${transactionId}/history`,
            transactionId,
            languageId,
            token,
        ];
    } else return [`${API_URL}/transaction/history`, transactionId, languageId];
};
